import React, { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { RoutePermissionGuard } from '@shared/auth/RoutePermissionGuard';
import { Role } from '@shared/auth/AuthContext';

const TimetablePage = lazy(() => import('./modules/timetable/pages/TimetablePage').then(m => ({ default: m.TimetablePage })));
const BatchesPage = lazy(() => import('./modules/batches/pages/BatchesPage').then(m => ({ default: m.BatchesPage })));
const RoomsPage = lazy(() => import('./modules/rooms/pages/RoomsPage').then(m => ({ default: m.RoomsPage })));
const CalendarPage = lazy(() => import('./modules/timetable/pages/CalendarPage').then(m => ({ default: m.CalendarPage })));

// Live Tuition & Pairings
const MasterClassSchedulerPage = lazy(() => import('./modules/timetable/pages/MasterClassSchedulerPage').then(m => ({ default: m.MasterClassSchedulerPage })));
const FacultyStudentPairingPage = lazy(() => import('./modules/pairings/pages/FacultyStudentPairingPage').then(m => ({ default: m.FacultyStudentPairingPage })));

const BATCH_ROLES: Role[] = ['owner', 'admin', 'branch_head', 'counselor', 'teacher'];
const ROOM_ROLES: Role[] = ['owner', 'admin', 'branch_head'];
const FACULTY_ROLES: Role[] = ['owner', 'admin', 'branch_head', 'teacher'];

export const schedulingRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="timetable" replace />,
  },
  {
    path: 'timetable',
    handle: { crumb: 'Timetable Builder' },
    element: <TimetablePage />,
  },
  {
    path: 'batches',
    handle: { crumb: 'Batch Directory' },
    element: (
      <RoutePermissionGuard permission="batches.manage" allowedRoles={BATCH_ROLES}>
        <BatchesPage />
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'rooms',
    handle: { crumb: 'Classrooms & Labs' },
    element: (
      <RoutePermissionGuard permission="rooms.manage" allowedRoles={ROOM_ROLES}>
        <RoomsPage />
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'calendar',
    handle: { crumb: 'Academic Calendar' },
    element: <CalendarPage />,
  },
  {
    path: 'master-classes',
    handle: { crumb: 'Master Class Scheduler' },
    element: (
      <RoutePermissionGuard permission="sessions.manage" allowedRoles={FACULTY_ROLES}>
        <MasterClassSchedulerPage />
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'assignments',
    handle: { crumb: 'Faculty-Student Pairing' },
    element: (
      <RoutePermissionGuard allowedRoles={FACULTY_ROLES}>
        <FacultyStudentPairingPage />
      </RoutePermissionGuard>
    ),
  },
];

